export type ChatFeedbackRating = "up" | "down";

export const MESSAGE_FEEDBACK_REASONS = [
  "INCORRECT_OR_INCOMPLETE",
  "NOT_WHAT_I_ASKED",
  "SLOW_OR_BUGGY",
  "TONE",
  "OTHER",
] as const;

export type ChatFeedbackReason = (typeof MESSAGE_FEEDBACK_REASONS)[number];

export const REASON_LABEL: Record<ChatFeedbackReason, string> = {
  INCORRECT_OR_INCOMPLETE: "올바르지 않거나 끝까지 작성되지 않음",
  NOT_WHAT_I_ASKED: "요청한 내용이 아님",
  SLOW_OR_BUGGY: "느리거나 버그가 있음",
  TONE: "톤·문체",
  OTHER: "기타",
};

export interface ChatFeedbackItem {
  messageId: string;
  sessionId: string;
  sessionTitle: string | null;
  workspaceId: string | null;
  userId: string | null;
  userEmail: string | null;
  userName: string | null;
  rating: ChatFeedbackRating;
  reasons: string[];
  details: string | null;
  messageContentPreview: string;
  messageCreatedAt: string;
  feedbackCreatedAt: string;
  feedbackUpdatedAt: string;
}

export interface ChatFeedbacksFilters {
  rating?: ChatFeedbackRating;
}

export interface ChatSessionMessage {
  messageId: string;
  role: "user" | "assistant" | "system";
  content: string;
  createdAt: string;
  feedbackRating: ChatFeedbackRating | null;
  feedbackReasons: string[] | null;
  feedbackDetails: string | null;
}

export interface ChatSessionDetail {
  sessionId: string;
  title: string | null;
  workspaceId: string | null;
  sessionCreatedAt: string | null;
  feedbackMessageId: string;
  truncated: boolean;
  messages: ChatSessionMessage[];
}
